import { Spin } from "antd";
import styled, { css } from "styled-components";

export const Container = styled.div`
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.03);
  border-radius: 10px;
  margin-bottom: 40px;
  position: relative;
  min-height: 150px;

  .other-courses-body {
    width: 100%;
    position: relative;
    padding: 0 25px 5px;

    .carousel-container {
      width: 100%;
      overflow-x: hidden;
      overflow-y: visible;
      padding-bottom: 200px;
      margin-bottom: -200px;
    }
  }

  color: ${({ theme }) => theme.colors.textColor};
  background: ${({ theme }) => theme.colors.modalBackgroundColor};

  .slick-track {
    width: max-content !important;
  }

  .slick-slide,
  .div-child {
    min-width: 300px;
    max-width: 400px;
  }

  h1 {
    margin: 5px 0;
    padding: 20px;
    font-size: 20px;
    font-weight: 400;

    border-bottom: 1px solid;
    border-bottom-color: ${({ theme }) => theme.colors.backgroundColor};
  }
`;

export const Loader = styled(Spin)`
  width: 100%;
  height: 340px;

  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 700px) {
    height: 470px;
  }
`;
